export const ADD_CHOICE = 'dialogs/addDialog';
export const ADD_CHOICE_SUCCESS = 'dialogs/addDialogSuccess';
export const ADD_CHOICE_ERROR = 'dialogs/addDialogError';

export const ADD_QUOTE = 'dialogs/addQuote';
export const ADD_QUOTE_SUCCESS = 'dialogs/addQuote';
export const ADD_QUOTE_ERROR = 'dialogs/addQuote';

export const REMOVE_QUOTE = 'dialogs/removeQuote';
